export default __webpack_public_path__ + "static/media/loading.cb414b58.svg";